import { useEffect } from 'react';
import { useUrl } from '../useUrl/useUrl';

/**
 * Remembers a page element in session storage to later be able to restore scroll position to it.
 *
 * @param id A DOM element ID to scroll to, usually a product SKU or similar identifier.
 * @param path The current path on which the element was shown.
 */
export const rememberPageData = (id: string, path: string) => {
  window.sessionStorage.setItem('rememberedPageData', JSON.stringify({ id, path }));
};

export const useScrollRestoration = () => {
  const asPath = useUrl(true);

  useEffect(() => {
    const pageData = window.sessionStorage.getItem('rememberedPageData');
    if (pageData) {
      const rememberedData = JSON.parse(pageData);
      if (rememberedData.path === asPath) {
        const element = document.getElementById(rememberedData.id);
        if (element) {
          requestAnimationFrame(() => element.scrollIntoView({ block: 'center' }));
        }
      }
      window.sessionStorage.removeItem('rememberedPageData');
    }
  }, [asPath]);
};
